var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.parentRow.row))]),_c('img',{attrs:{"src":"favicon.ico","width":"30"}})])}
var staticRenderFns = []

export { render, staticRenderFns }